import { useCallback } from 'react';
import { useMessagePort } from 'providers/message-channel';

type RedirectOptions = {
  pathname: string;
  searchParams?: URLSearchParams;
  gatewayUrl: string;
  redirectParam?: string;
};

export function useRedirectToGateway() {
  const { sendExitStore } = useMessagePort();

  const redirectToGateway = useCallback(
    async ({ pathname, searchParams, gatewayUrl, redirectParam = 'redirect' }: RedirectOptions): Promise<void> => {
      try {
        // If we're already running inside a parent, we have no way to reauth 
        // so the only thing we can do is exit and force the user to re-enter. 
        sendExitStore();

        // if we're still here after calling exit store, then we must not have been running inside a parent,
        // so we want to redirect to the gateway, so we can reopen the page in the parent
        await new Promise((resolve) => setTimeout(resolve, 500));

        const qs = searchParams?.toString();
        const fullPath = qs ? `${pathname}?${qs}` : pathname;
        const url = `${gatewayUrl}?${redirectParam}=${encodeURIComponent(fullPath)}`;
        globalThis.top?.location.replace(url);
      } catch (error) {
        // Shouldn't ever get here, because we should always be able to either exit the store or redirect
        console.error('Failed to redirect to gateway:', error);
      }
    },
    [sendExitStore],
  );

  return redirectToGateway;
}
